export default (filename, blob) => {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.style.display = 'none';
  link.href = url;
  console.log('url', url);
  link.setAttribute('download', filename);
  if (typeof link.download === 'undefined') {
    link.setAttribute('target', '_blank');
  }
  document.body.appendChild(link);
  link.click();
  setTimeout(() => {
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }, 1000);
};
